import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
  // {
  //   path: '/',
  //   component: () => import('../views/home/home.vue'),
  //   redirect: 'home',
  // },
  {
    path: '/',
    component: () => import('../views/home/home.vue'),
    redirect: 'dialogue',
    children: [
      {
        path: 'dialogue',
        name: 'dialogue',
        component: () => import('../views/dialogue/dialogue.vue')
      },
      {
        path: 'my',
        name: 'my',
        component: () => import('../views/my/my.vue')
      },
      {
        path: 'assistant',
        name: 'assistant',
        component: () => import('../views/assistant/assistant.vue')
      },
      {
        path: 'intelligentBody',
        name: 'intelligentBody',
        component: () => import('../views/intelligentBody/intelligentBody.vue')
      },
      {
        path: 'classroom',
        name: 'classroom',
        component: () => import('../views/classroom/classroom.vue')
      },
      {
        path: 'classroomDetail',
        name: 'classroomDetail',
        component: () => import('../views/classroom/classroomDetail.vue')
      },
      {
        path: 'classroomInfo',
        name: 'classroomInfo',
        component: () => import('../views/classroom/classroomInfo.vue')
      },
      {
        path: 'classroomInfo1',
        name: 'classroomInfo1',
        component: () => import('../views/classroom/classroomInfo1.vue')
      },
      {
        path: 'classList',
        name: 'classList',
        component: () => import('../views/class/classList.vue')
      },
      {
        path: 'classDetail',
        name: 'classDetail',
        component: () => import('../views/class/classDetail.vue')
      },
      {
        path: 'simultaneousInterpretation',
        name: 'simultaneousInterpretation',
        component: () => import('../views/classroom/simultaneousInterpretation.vue')
      },
      {
        path: 'simultaneousInterpretationRecord',
        name: 'simultaneousInterpretationRecord',
        component: () => import('../views/classroom/simultaneousInterpretationRecord.vue')
      },
      {
        path: 'simultaneousInterpretationInfo',
        name: 'simultaneousInterpretationInfo',
        component: () => import('../views/classroom/simultaneousInterpretationInfo.vue')
      },
      {
        path: 'resource',
        name: 'resource',
        component: () => import('../views/resource/resource.vue')
      },
      {
        path: 'intelligentBodyChat',
        name: 'intelligentBodyChat',
        component: () => import('../views/intelligentBody/intelligentBodyChat.vue')
      },
      {
        path: 'callWord',
        name: 'callWord',
        component: () => import('../views/assistant/callWord.vue')
      },
      {
        path: 'chat',
        name: 'chat',
        component: () => import('../views/assistant/chat.vue')
      },
      {
        path: 'classroomIntelligentBody',
        name: 'classroomIntelligentBody',
        component: () => import('../views/classroomIntelligentBody/classroomIntelligentBody.vue')
      },
      {
        path: 'createClassroomIntelligentBody',
        name: 'createClassroomIntelligentBody',
        component: () => import('../views/classroomIntelligentBody/createClassroomIntelligentBody.vue')
      },
      //
      {
        path: 'trClassroom',
        name: 'trClassroom',
        component: () => import('../views/teachingResearch/classroom.vue')
      },
      {
        path: 'trClassroomDetail',
        name: 'trClassroomDetail',
        component: () => import('../views/teachingResearch/classroomDetail.vue')
      },
      {
        path: 'trClassroomInfo',
        name: 'trClassroomInfo',
        component: () => import('../views/teachingResearch/classroomInfo.vue')
      },
      {
        path: 'trClassList',
        name: 'trClassList',
        component: () => import('../views/teachingResearch/classList.vue')
      },
      {
        path: 'trClassDetail',
        name: 'trClassDetail',
        component: () => import('../views/teachingResearch/classDetail.vue')
      },
      {
        path: 'dimension',
        name: 'dimension',
        component: () => import('../views/teachingResearch/dimension.vue')
      },
      {
        path: 'classroomIntelligentBodyCreate',
        name: 'classroomIntelligentBodyCreate',
        component: () => import('../views/classroom/classroomIntelligentBodyCreate.vue')
      },
      {
        path: 'classManage',
        name: 'classManage',
        component: () => import('../views/schoolManage/classManage.vue')
      },
      {
        path: 'classDetailManage',
        name: 'classDetailManage',
        component: () => import('../views/schoolManage/classDetail.vue')
      },
      {
        path: 'classRoomManage',
        name: 'classRoomManage',
        component: () => import('../views/schoolManage/classRoomManage.vue')
      },
      {
        path: 'classroomInfoManage',
        name: 'classroomInfoManage',
        component: () => import('../views/schoolManage/classroomInfo.vue')
      },
      {
        path: 'intelligentBodyManage',
        name: 'intelligentBodyManage',
        component: () => import('../views/schoolManage/intelligentBodyManage.vue')
      },
      {
        path: 'accountManage',
        name: 'accountManage',
        component: () => import('../views/schoolManage/accountManage.vue')
      },
      {
        path: 'intelligentBodyRecord',
        name: 'intelligentBodyRecord',
        component: () => import('../views/intelligentBody/intelligentBodyRecord.vue')
      },
      {
        path: 'historyChat',
        name: 'historyChat',
        component: () => import('../views/assistant/historyChat.vue')
      },
      {
        path: 'experienceClassRoom',
        name: 'experienceClassRoom',
        component: () => import('../views/classroom/experienceClassRoom.vue')
      },
      {
        path: 'questionBankManage',
        name: 'questionBankManage',
        component: () => import('../views/classroom/questionBankManage.vue')
      },
      {
        path: 'questionCreate',
        name: 'questionCreate',
        component: () => import('../views/classroom/questionCreate.vue')
      },
      {
        path: 'questionInfo',
        name: 'questionInfo',
        component: () => import('../views/classroom/questionInfo.vue')
      },
      {
        path: 'detailedStatistics',
        name: 'detailedStatistics',
        component: () => import('../views/classroom/detailedStatistics.vue')
      },
      {
        path: 'demo',
        name: 'demo',
        component: () => import('../views/dialogue/demo.vue')
      },
      {
        path: 'archivesClassList',
        name: 'archivesClassList',
        component: () => import('../views/class/archivesClassList.vue')
      },
      {
        path: 'archivesStudentList',
        name: 'archivesStudentList',
        component: () => import('../views/class/archivesStudentList.vue')
      },
      {
        path: 'archivesList',
        name: 'archivesList',
        component: () => import('../views/class/archivesList.vue')
      },
      {
        path: 'stuArchivesList',
        name: 'stuArchivesList',
        component: () => import('../views/class/studentArchivesList.vue')
      },
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/login.vue')
  },
  {
    path: '/logins',
    name: 'logins',
    component: () => import('../views/logins.vue')
  },
  {
    path: '/xs',
    name: 'xs',
    component: () => import('../views/xs.vue')
  },
  {
    path: '/student',
    component: () => import('../views/student/studentHome.vue'),
    redirect: '/student/studentHomePage',
    children:[
      {
        path: 'studentHomePage',
        name: 'studentHomePage',
        component: () => import('../views/student/studentHomePage.vue')
      },
      {
        path: 'studentIntelligentBodyDialogue',
        name: 'studentIntelligentBodyDialogue',
        component: () => import('../views/student/studentIntelligentBodyDialogue.vue')
      }
    ]
  },
  {
    path: '/teachingResearch',
    component: () => import('../views/student/studentHome.vue'),
    redirect: '/teachingResearch/studentHomePage',
    children:[
      {
        path: 'teachingResearchHomePage',
        name: 'teachingResearchHomePage',
        component: () => import('../views/teachingResearch/teachingResearchHomePage.vue')
      },
      {
        path: 'teachingResearchIntelligentBodyDialogue',
        name: 'teachingResearchIntelligentBodyDialogue',
        component: () => import('../views/teachingResearch/teachingResearchIntelligentBodyDialogue.vue')
      }
    ]
  },
]


const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, saveTop) {
    if (saveTop) {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve(saveTop)
        }, 1000)
      })
      // return saveTop
    } else {
      return { x: 0, y: 0 }
    }
  },
})

// 前置路由守卫
router.beforeEach((to, from, next) => {
  const token = sessionStorage.getItem('token') || localStorage.getItem('token') || '';
  const loginType = sessionStorage.getItem('loginType')||localStorage.getItem('loginType') || '';

  if (!token && to.path !== '/login') {
    // 未登录且不是去登录页，跳转登录页
    next('/login');
    return;
  }


  if (token) {
    if (loginType === '1') {
      // loginType=1，允许访问除了 /student 和 /teachingResearch 开头的页面
      if (to.path.startsWith('/student') || to.path.startsWith('/teachingResearch')) {
        next('/'); // 跳转默认首页或者你想跳转的页面
      } else {
        next();
      }
    } else if (loginType === '2') {
      // loginType=2，只允许访问 /student 开头的页面
      if (to.path.startsWith('/student')) {
        next();
      } else {
        next('/student/studentHomePage'); // 跳转到学生首页或者你想跳转的页面
      }
    } else if (loginType === '3') {
      // loginType=3，只允许访问 /teachingResearch 开头的页面
      if (to.path.startsWith('/teachingResearch')) {
        next();
      } else {
        next('/teachingResearch'); // 跳转到教学研究首页或者你想跳转的页面
      }
    } else {
      // 其他情况，默认放行
      next();
    }
  } else {
    // 没有token且访问登录页，放行
    next();
  }

  // if (to.path !== '/login' && !token) {
  //   next('/login');
  // } else {
  //   next();
  // }
})


export default router
